export default {
    'add-category': 'إضافة تصنيف',
    'edit-category': 'تعديل',
    'the-category': 'التصنيف'
}